import useAppStore from "@/store/use-app-store";
import { Close } from "@mui/icons-material";
import { Alert, Box, Button, IconButton } from "@mui/material";
import { appear } from "data/styles/styleGlobals";
import React from "react";
import { usePWAInstall } from "react-use-pwa-install";

export default function PWAAlert() {
  const { PWADisagree } = useAppStore();
  // PWA
  const install = usePWAInstall();
  const [pwaOpen, setPwaOpen] = React.useState(false);

  React.useEffect(() => {
    if (PWADisagree === true) return;
    if (install && typeof install === "function" && !PWADisagree) {
      setPwaOpen(true);
      const timer = setTimeout(() => setPwaOpen(false), 30 * 1000);
      return () => clearTimeout(timer);
    }
  }, [install, PWADisagree]);

  return (
    <>
      {/* PWA Баннер */}
      {pwaOpen && (
        <Alert
          action={
            <Box sx={{ display: "flex", flexDirection: "row", gap: "6px" }}>
              <Button
                onClick={() => {
                  install();
                  useAppStore.setState({
                    PWADisagree: true,
                  });
                }}
                size="small"
                sx={{ fontWeight: 500 }}
                variant="contained"
              >
                Добавить
              </Button>
              <IconButton
                onClick={() => {
                  setPwaOpen(false);
                  useAppStore.setState({
                    PWADisagree: true,
                  });
                }}
                size="small"
                sx={{ fontWeight: 500 }}
                variant="contained"
              >
                <Close fontSize="inherit" />
              </IconButton>
            </Box>
          }
          icon={false}
          severity={"info"}
          sx={{
            ".MuiAlert-action": {
              alignItems: "center",
              justifyContent: "center",
              marginLeft: "unset",
            },
            ".MuiAlert-message": {
              marginLeft: "auto",
              marginRight: "auto",
              textWrap: "balance",
            },
            animation: `${appear} .4s ease-in-out`,
            background: "#4d575c",
            bottom: "42px",
            color: "#fff",
            justifyContent: "center",
            position: "absolute",
            textAlign: "center",
            whiteSpace: "pre-line",
            width: "100%",
            zIndex: 2000,
          }}
          variant="filled"
        >
          Добавить ярлык на рабочий стол?
        </Alert>
      )}
    </>
  );
}
